import { isNull, isUndefined } from 'lodash';
import { useEffect, useState } from 'react';

export const useLocalStorage = <T>(key: string, initialValue?: T) => {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);

      if (item) {
        return JSON.parse(item);
      }
    } catch (error) {
      console.log(error);
      return initialValue;
    }

    return initialValue;
  });

  useEffect(() => {
    if (!isNull(state) && !isUndefined(state)) {
      try {
        window.localStorage.setItem(key, JSON.stringify(state));
      } catch (error) {
        console.log(error);
      }
    }
  }, [state, key]);

  return [state, setState];
};
